import { useOrganization } from "@/queries/organization-queries";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";

/**
 * Hook that checks if local runner functionality is allowed for the current organization tier.
 *
 * Returns true only for ENTERPRISE tier.
 * Returns false for FREE_ONA, CORE, and FREE tiers.
 */
export function useIsLocalRunnerAllowedForTier() {
    const { data: organization, isPending, fetchStatus } = useOrganization();

    const tier = organization?.tier;

    // Only ENTERPRISE tier allows local runners
    const isEnterprise = tier === OrganizationTier.ENTERPRISE;

    // When the query is disabled (fetchStatus === "idle"), treat it as not loading.
    // This happens when the user is not authenticated or the principal doesn't match.
    // In this case, we default to allowing local runners (isAllowed: true when tier is undefined).
    const isActuallyLoading = isPending && fetchStatus !== "idle";

    return {
        isAllowed: tier === undefined || isEnterprise,
        isLoading: isActuallyLoading,
    };
}
